import React from 'react';


import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUndo, faPlus, faMinus, faSave, faTrashAlt, faLock, faLockOpen, faRandom, faChevronRight,
  faCheckSquare, faSquare, faEye, faEyeSlash, faCompress, faExpand, faImages, faQuestionCircle
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FAButtonWrapper } from './FAButton.styles';

library.add(
  faUndo, faPlus, faMinus, faSave, faTrashAlt, faLock, faLockOpen, faRandom, faChevronRight,
  faCheckSquare, faSquare, faEye, faEyeSlash, faCompress, faExpand, faImages, faQuestionCircle
);

export type Icon =
  'undo' | 'plus' | 'minus' | 'save' | 'trash-alt' | 'lock' | 'lock-open' | 'random' | 'chevron-right'
  | 'check-square' | 'square' | 'eye' | 'eye-slash' | 'compress' | 'expand' | 'images' | 'question-circle';

export type FAButtonProps = {
  icon: Icon,
  size?: number,
  onClick?: () => void;

  id?: string;
};

export const FAButton: React.FC<FAButtonProps> = ({ icon, size, onClick, id, children, ...rest }) => {

  const click = onClick ? ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => { 
    // button clicks don't bleed through
    event.stopPropagation();
    onClick();
  }) : undefined;

  return (
    <FAButtonWrapper id={id} className='FAButton' onClick={click} style={{
      width: (size || 28) * 1.2,
      height: (size || 28) * 1.2
    }} {...rest}>
      <FontAwesomeIcon icon={icon} size='2x' style={{
        transform: size ? `scale(${size / 28})` : undefined,
        transformOrigin: 'center'
      }}/>
    </FAButtonWrapper>
  );
};